export default "__VITE_ASSET__CzKR6Zam__"